module.exports = __webpack_public_path__ + "static/media/snacks_default.b83881ca.svg";